import { createActionCreator } from '@pressreader/appstore';
import { IDeviceInfo, IScreenInfo } from '@pressreader/ui-types';

const pre = 'ui/common/';

interface IDeviceInfoLoadedPayload {
    device: IDeviceInfo;
}

interface IScreenChangedPayload {
    prevScreen: IScreenInfo;
    screen: IScreenInfo;
}

interface ITopbarHeightChangedPayload {
    topbarHeight: number;
}

interface INotifyScreenReaderPayload {
    message: string;
}

interface IScreenReaderNotifiedPayload {
    message: string;
}

// Sets the Redux device snapshot — seeded at init from the static device, and the override
// hook for config-driven form-factor (e.g. AB#173904 force web view by siteID).
export const deviceInfoLoaded = createActionCreator<IDeviceInfoLoadedPayload>(`${pre}device_info_loaded`);

export const screenResized = createActionCreator(`${pre}screen_resized`);
export const screenChanged = createActionCreator<IScreenChangedPayload>(`${pre}screen_changed`);

export const topbarHeightChanged = createActionCreator<ITopbarHeightChangedPayload>(`${pre}topbar_height_changed`);

export const notifyScreenReaderAction = createActionCreator<INotifyScreenReaderPayload>(`${pre}notify_screen_reader`);
export const screenReaderNotified = createActionCreator<IScreenReaderNotifiedPayload>(`${pre}screen_reader_notified`);
export const clearScreenReaderNotificationAction = createActionCreator(`${pre}clear_screen_reader_notification`);
